export default "__VITE_ASSET__Bz5Scqo9__"